import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useStudentsBillingStore } from "../../../../Store/CashControlStore/StudentsBillingStore";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: "37px",
    minHeight: "37px",
    width: "200px",
    fontSize: "13px",
    fontFamily: "Inter",
    fontWeight: "400",
  }),
};

export default function Selector({ options, property }) {
  const { updateParams, loadItems, queryParams, setLoading } =
    useStudentsBillingStore();
  const { t } = useTranslation();

  const handleSelectChange = useCallback(async (e) => {
    setLoading(true);
    if (property === t("O'qituvchi")) {
      updateParams({ teacher: e?.value == undefined ? "" : e?.value, page: 1 });
      await loadItems(
        new URLSearchParams({
          ...queryParams,
          teacher: e?.value == undefined ? "" : e?.value,
          page: 1,
        }).toString()
      );
    }
    if (property === t("Filial")) {
      updateParams({ branch: e?.value == undefined ? "" : e?.value, page: 1 });
      await loadItems(
        new URLSearchParams({
          ...queryParams,
          branch: e?.value == undefined ? "" : e?.value,
          page: 1,
        }).toString()
      );
    }
    setLoading(false);
  });

  return (
    <div className="normal-select-bar">
      <Select
        className="basic-single manage_group_select"
        classNamePrefix="select"
        placeholder={property}
        styles={customStyles}
        options={options}
        isClearable
        onChange={handleSelectChange}
      />
    </div>
  );
}
